import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { ProveedorCreateInterface } from "../../interfaces/proveedorInterfaces/ProveedorCreate.interface";
import { ProveedorInterface } from "../../interfaces/proveedorInterfaces/Proveedor.interface";

export async function ProveedorCreateAction(
  prveedor: ProveedorCreateInterface
): Promise<ApiResponse<ProveedorInterface>> {
  const { data } = await apiClient.post<ProveedorInterface>(
    "/gpProveedoresProducto",
    prveedor
  );
  return {
    status: 200,
    data,
    message: "Proveedor de producto creada correctamente",
  };
}
